import { Controller } from "@hotwired/stimulus"

// Índice único por fila nueva. Date.now() solo se repetía cuando llegaban
// varias filas en el mismo tick (formato-ia agrega todos los videos de una
// vez) y se pisaban; el autoguardado además usa este índice como clave de la
// fila para devolverle su id.
let secuencia = 0
const indiceNuevo = () => `${Date.now()}${String(secuencia++ % 1000).padStart(3, "0")}`

// Campos anidados (links, archivos adjuntos, subtemas extra).
// Reemplaza a cocoon: el <template> trae la fila en blanco con NEW_RECORD como
// marcador de índice, y al eliminar se marca _destroy en vez de borrar el DOM
// cuando el registro ya existe en la base de datos. Cada alta o baja emite
// "nested-form:cambio" (lo escucha el autoguardado).
export default class extends Controller {
  static targets = ["template", "container", "item"]

  add(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, indiceNuevo())
    this.containerTarget.insertAdjacentHTML("beforeend", html)
    this.containerTarget.lastElementChild?.querySelector("input, select, textarea")?.focus()
    this.dispatch("cambio")
  }

  // Fila nueva ya rellenada, disparada por otro componente vía CustomEvent
  // (la pauta registra su link también en "Referencias"). El detail trae
  // { campo: valor } con los nombres de las columnas. No duplica URLs.
  addConValores(event) {
    const valores = event.detail || {}
    if (valores.url) {
      const urls = [...this.containerTarget.querySelectorAll("input[name*='[url]']")]
      if (urls.some((input) => input.value.trim() === valores.url)) return
    }

    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, indiceNuevo())
    this.containerTarget.insertAdjacentHTML("beforeend", html)
    const fila = this.containerTarget.lastElementChild
    Object.entries(valores).forEach(([campo, valor]) => {
      const input = fila?.querySelector(`input[name*='[${campo}]']`)
      if (input) input.value = valor
    })
    this.dispatch("cambio")
  }

  remove(event) {
    event.preventDefault()
    const item = event.target.closest("[data-nested-form-target='item']")
    if (!item) return

    const destroyField = item.querySelector("input[name*='_destroy']")
    if (destroyField) {
      // Registro persistido: se marca para borrar y se oculta.
      destroyField.value = "1"
      item.classList.add("hidden")
    } else {
      item.remove()
    }
    this.dispatch("cambio")
  }
}
